import { render, staticRenderFns } from "./ManagePopupMetadata.vue?vue&type=template&id=68ad78e4&scoped=true&"
import script from "./ManagePopupMetadata.vue?vue&type=script&lang=js&"
export * from "./ManagePopupMetadata.vue?vue&type=script&lang=js&"
import style0 from "./ManagePopupMetadata.vue?vue&type=style&index=0&id=68ad78e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad78e4",
  null
  
)

export default component.exports